import { render, staticRenderFns } from "./TreatmentDialog.vue?vue&type=template&id=05791edf&"
import script from "@/views/Curricula/TreatmentDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/Curricula/TreatmentDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Curricula/TreatmentDialog.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports